import { render, staticRenderFns } from "./SalesAdm.vue?vue&type=template&id=292b965f&"
import script from "./SalesAdm.vue?vue&type=script&lang=js&"
export * from "./SalesAdm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports